import React from 'react';
import { BoxSeam, Bug, RocketTakeoff, Terminal } from 'react-bootstrap-icons';

interface IAnnTypeIcon {
  type?: string;
  className?: string;
}
export const AnnouncementTypeIcon = ({ type, className }: IAnnTypeIcon) => {
  if (type === 'dependency') return <BoxSeam className={className} />;

  if (type === 'technical') return <Terminal className={className} />;

  if (type === 'bugfix') return <Bug className={className} />;

  if (type === 'feature') return <RocketTakeoff className={className} />;

  return null;
};
